import {configureStore} from "@reduxjs/toolkit"
import {setupListeners} from "@reduxjs/toolkit/query";
import {wikiAPI} from "../api/wp";
import authReducer from "./reducers/authSlice";
import commonReducer from "./reducers/commonSlice";
import searchReducer from "./reducers/searchSlice";
import userReducer from "./reducers/userSlice";
import {authAPI} from "../api/auth";
import {pageAPI} from "../api/page";
import {featureAPI} from "../api/feature";
import {emailAPI} from "../api/email";
import {userAPI} from "../api/user";
import {logAPI} from "../api/log";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        common: commonReducer,
        search: searchReducer,
        user: userReducer,
        [wikiAPI.reducerPath]: wikiAPI.reducer,
        [authAPI.reducerPath]: authAPI.reducer,
        [pageAPI.reducerPath]: pageAPI.reducer,
        [featureAPI.reducerPath]: featureAPI.reducer,
        [emailAPI.reducerPath]: emailAPI.reducer,
        [userAPI.reducerPath]: userAPI.reducer,
        [logAPI.reducerPath]: logAPI.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        authAPI.middleware,
        wikiAPI.middleware,
        pageAPI.middleware,
        featureAPI.middleware,
        emailAPI.middleware,
        userAPI.middleware,
        logAPI.middleware,
    )
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

setupListeners(store.dispatch)